import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
	InputField: {
		'&.MuiInputBase-input MuiInput-input MuiInputBase-inputMultiline MuiInput-inputMultiline': {
			background: 'none',
		},
		'& .MuiInputBase-input MuiInput-input': {
			background: 'none',
		},
		'& .MuiInputBase-input': {
			background: '#FFFFFF !important',
			width: '95% !important',
		},
		'& .MuiOutlinedInput-input': {
			padding: '8.5px 12px',
		},
		'& .MuiOutlinedInput-multiline': {
			padding: '0px',
		},
		'& .MuiOutlinedInput-root': {
			borderRadius: '8px',
		},
		'&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
			borderColor: '#565A5C',
		},
		'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: '#14a0d6',
		},
	},
	Card: {
		borderRadius: '8px',
		boxShadow: '0px 3px 6px #00000029',
		width: '460px',
		minHeight: '124px',
		'& .MuiCardContent-root:last-child': {
			paddingBottom: theme.spacing(2),
		},
		'&:hover': {
			boxShadow: '0px 4px 6px #00000063',
		},
	},
	actions2: {
		justifyContent: 'flex-end',
		'& .MuiButtonBase-root': {
			color: '#007DBA !important',
			font: 'normal normal normal 14px/17px Roboto',
			'&:hover': {
				background: 'none',
			},
		},
	},
	formControl: {
		margin: theme.spacing(1),
		//width: '280px',
		marginLeft: '0px',

		'&:hover': {
			'& .MuiInputBase-input': {
				background: '#007DBA !important',
				color: '#FFFFFF',
			},
			'& > .MuiInputLabel-formControl': {
				color: '#FFF',
			},
			'& .MuiSvgIcon-root': {
				color: '#FFF !important',
			},
		},
		'& > .MuiInputLabel-formControl': {
			lineHeight: 0,
			color: '#007DBA',
			marginTop: '-2px',
		},
		'& .MuiSvgIcon-root': {
			color: '#007DBA !important',
		},
		'& .MuiInputLabel-shrink': {
			color: '#098BBD',
		},
	},
	formControlQuote: {
		margin: theme.spacing(1),
		//width: '280px',
		marginLeft: '0px',

		'&:hover': {
			'& .MuiInputBase-input': {
				background: '#007DBA !important',
				color: '#FFFFFF',
			},
			'& > .MuiInputLabel-formControl': {
				color: '#FFF',
			},
			'& .MuiSvgIcon-root': {
				color: '#FFF !important',
			},
		},
		'& > .MuiInputLabel-formControl': {
			lineHeight: 0,
			color: '#007DBA',
			marginTop: '-2px',
		},
		'& .MuiSvgIcon-root': {
			color: '#007DBA !important',
		},
		'& .MuiInputLabel-shrink': {
			color: '#007DBA',
		},
	},
	formSelectQuote: {
		width: '100%',
		'& .MuiSelect-select': {
			border: '2px solid #007DBA',
			background: '#FFF',
			height: '0px',
			borderRadius: '4px',
			padding: '16px',
			paddingTop: '8px',
			paddingBottom: '24px',
		},
	},
	formSelect: {
		width: '100%',
		'& .MuiSelect-select': {
			border: '2px solid #007DBA',
			background: '#FFFFFF',
			height: '0px',
			borderRadius: '4px',
			padding: '16px',
			paddingTop: '8px',
			paddingBottom: '24px',
		},
	},
	headerMenuLinkActive: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: '100%',
		width: '100%',
		fontWeight: 'bold',
		padding: '13px',
		paddingTop: theme.spacing(2),
		borderBottom: `${theme.palette.primary.main} 4px solid`,
		color: theme.palette.text.primary,
		'&:hover': {
			backgroundColor: theme.palette.background.paper,
		},
	},
	openCardTypography: {
		marginBottom: '1em !important',
		font: 'normal normal normal 14px/17px Roboto',
		color: '#002855',
	},
	openCardTypographyLabelInput: {
		marginBottom: '4px !important',
		font: 'normal normal normal 14px/17px Roboto',
		color: '#002855',
	},
	openCardTime: {
		font: 'normal normal normal 16px/19px Roboto',
		color: '#002855',
	},
	openCardTitle: {
		font: 'normal normal normal 20px/24px Roboto',
		color: '#002855',
	},
	wireframeCard: {
		boxShadow: '0px 3px 6px #00000029',
		width: '460px',
		height: '131px',
		borderRadius: '8px',
	},
	subTitleViewEvacuation: {
		font: 'normal normal normal 14px/17px Roboto',
		color: '#002855',
	},
	menuButton: {
		'&:hover': {
			backgroundColor: 'white',
			cursor: 'auto',
		},
	},
	menuButton2: {
		'&:hover': {
			backgroundColor: 'rgba(102, 204, 250, 0.2)',
			color: '#002855',
		},
		color: '#002855',
	},
	feedAlignment: {
		marginBottom: '2px',
	},
	openCard: {
		backgroundColor: 'white !important',
	},
	openCardDialog: {
		'& .MuiPaper-root': {
			backgroundColor: 'transparent',
		},
		'& .MuiDialog-paperWidthSm': {
			maxWidth: 'none !important',
			borderRadius: '8px',
			boxShadow: '0px 5px 8px #00000063',
			width: '33%',
			'@media (max-width:768px)': {
				width: '90%',
			},
		},
		boxShadow: '0px 5px 8px #00000063',
	},
	openCardDialogQuote: {
		'& .MuiPaper-root': {
			backgroundColor: 'transparent',
		},
		'& .MuiDialog-paperWidthSm': {
			maxWidth: 'none !important',
			borderRadius: '8px',
			boxShadow: '0px 5px 8px #00000063',
			width: '50%',
			'@media (max-width:768px)': {
				width: '90%',
			},
		},
		boxShadow: '0px 5px 8px #00000063',
	},
	ActionButtons: {
		marginTop: '15px',
		height: '35px',
		backgroundColor: '#007DBA',
		color: '#FFFFFF',
		marginLeft: '0px',
		'&:hover': {
			backgroundColor: '#56b1df',
			color: '#FFFFFF',
		},
		'&.Mui-disabled': {
			backgroundColor: '#cfdbe5 !Important',
			color: '#FFFFFF',
		},
		'& .MuiButton-label': {
			marginTop: '1px',
		},
	},
	ActionButtonsQuote: {
		minWidth: '125px',
		marginRight: '10px',
		marginTop: '15px',
		height: '35px',
		backgroundColor: '#007DBA',
		color: '#FFFFFF',
		marginLeft: '0px',
		'&:hover': {
			color: '#FFFFFF',
		},
		'&.Mui-disabled': {
			color: '#adc1d3',
			backgroundColor: '#cfdbe5',
		},
		'& .MuiButton-label': {
			marginTop: '1px',
		},
	},
	ActionButtons2: {
		color: '#007DBA',
		border: '1px solid #007DBA',
		'&:hover': {
			backgroundColor: '#007DBA',
			color: '#FFFFFF',
			border: '1px solid #007DBA',
		},
	},
	formControlLabel: {
		display: 'none',
	},
	cancelbtn: {
		width: '76px',
		height: '36px',

		marginTop: '15px',
		color: '#007DBA',
		backgroundColor: '#FFFFFF',
		border: '1px solid #007DBA',
		'&:hover': {
			color: '#FFFFFF',
			backgroundColor: '#007DBA',
		},
		'&:focus-visible': {
			color: '#007DBA !important',
			backgroundColor: '#FFFFFF !important',
			border: '2px solid #002855 !important',
		},
		'& .MuiButton-label': {
			marginTop: '1px',
		},
		// '& .MuiButton-outlined': {
		// 	border: '2px solid red',
		// },
	},
	cancelbtnQuote: {
		width: '125px',
		height: '36px',

		marginTop: '15px',
		color: '#007DBA',
		border: '1px solid #007DBA',
		backgroundColor: '#FFFFFF',
		'& .MuiButton-label': {
			marginTop: '1px',
		},
		'&:hover': {
			color: '#FFFFFF',
			backgroundColor: '#007DBA',
		},
		'&:focus-visible': {
			color: '#007DBA !important',
			backgroundColor: '#FFFFFF !important',
			border: '2px solid #002855 !important',
		},
		// '& .MuiButton-outlined': {
		// 	border: '2px solid red',
		// },
	},
	closebtn: {
		border: '1px solid transparent',
		'&:hover': {
			border: '1px solid #007DBA',
		},
	},
	actions: {
		justifyContent: 'flex-end',
	},
	CardHeader: {
		backgroundColor: '#CFDBE5',
		height: '37px',
		borderRadius: '8px 8px 0px 0px',
	},
	CardHeaderApproval: {
		backgroundColor: '#CFDBE5',
		height: '37px',
		borderRadius: '8px 8px 0px 0px',
	},
	CardContent: {
		paddig: '8px',
	},
	textItem: {
		alignSelf: 'flex-start',
	},
	actionArea: {
		'&:hover $focusHighlight': {
			opacity: 0,
		},
	},
	titleView: {
		height: '17px',
		width: '386px',
		marginTop: '-4px',
		font: 'normal normal normal 16px/19px Roboto',
		color: '#002855',
	},
	subTitleView: {
		color: '#565A5C',
	},
	timeView: {
		color: '#002855',
	},
	focusHighlight: {},
	statusFeed: {
		height: '125px',
		objectFit: 'fill',
	},
	Autocomplete: {
		'& .MuiInputLabel-root': {
			zIndex: 999,
			background: '#FFFFFF',
		},
		'& .MuiFormControl-marginNormal': {
			marginTop: '12px !important',
			marginBottom: '4px !important',
			left: '12px !important',
		},
		'& .MuiAutocomplete-inputRoot': {
			background: '#FFFFFF',
			width: '460px !important',
			height: '40px',
		},
		'@media (min-width: 0px) and (max-width: 600px)': {
			'& .MuiAutocomplete-inputRoot': {
				width: '460px !important',
			},
		},
		'@media (min-width: 950px) and (max-width: 1250px)': {
			'& .MuiAutocomplete-inputRoot': {
				width: '460px !important',
			},
		},

		'& .MuiInputBase-input': {
			background: '#FFFFFF',
		},
		'& .MuiAutocomplete-clearIndicator': {
			display: 'none',
		},
		'& .MuiAutocomplete-popupIndicatorOpen': {
			transform: 'none !important',
		},
		'& .MuiAutocomplete-root': {
			width: '110% !important',
		},
		'& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon': {
			paddingRight: '38px !important',
		},
		'& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
			paddingRight: '38px !important',
		},
		'& .MuiIconButton-root:hover': {
			backgroundColor: '#098BBD0A !important',
		},
		'& .MuiAutocomplete-option[data-focus="true"]': {
			backgroundColor: '#098BBD0A !important',
		},
	},
	AutoComplete1: {
		'& .MuiAutocomplete-popupIndicatorOpen': {
			transform: 'none !important',
		},
	},
	option: {
		'&[data-focus="true"]': {
			backgroundColor: '#f4f8fc',
		},
		'&[aria-selected="true"]': {
			backgroundColor: '#f4f8fc',
		},
	},
	selectStyle: {
		width: '460px',
	},
	searchIcon: {
		verticalAlign: 'middle',
		marginTop: '5px',
	},
}));

export default useStyles;
